/* eslint-disable import/prefer-default-export */
import { ApolloClient, InMemoryCache } from '@apollo/client';

import { BASE_API_URI } from '../../config';

export const client = new ApolloClient({
  uri: BASE_API_URI,
  cache: new InMemoryCache(),
});
